import style from './SkipNav.scss';

import React from 'react';
import { useTranslation } from 'react-i18next';

export type Props = {
  id: string;
  targetDomId: string;
};

export const SkipNav: React.FC<Props> = ({ id, targetDomId }) => {
  const { t } = useTranslation();
  return (
    <div className={style.skipLinkSkipNav}>
      <a id={id} href={`#${targetDomId}`} tabIndex={0} className={style.skipLink}>{t('skip-link')}</a>
    </div>
  );
};
